import { indexPagesData } from 'utils/index-pages-data';
import { ScorecardsTabComponent } from './components/segments-scorecard/scorecards-tab/scorecards-tab.component';
import { LogsComponent } from 'shared/logs/logs.component';
import { CommentsComponent } from 'shared/comments/comments.component';


export const rightPanelNavs: any[] = [
  {
    title: 'Scorecard',
    name: 'scorecard',
    active: false,
    component: ScorecardsTabComponent,
  },
  {
    title: 'Logs',
    name: 'logs',
    active: false,
    component: LogsComponent,
    availableFor: [...indexPagesData.working.itemStatuses],
  },
  {
    title: 'Comments',
    name: 'comments',
    active: false,
    component: CommentsComponent,
    availableFor: [
      ...indexPagesData.working.itemStatuses,
      ...indexPagesData.published.itemStatuses,
    ],
  }
];
